import produce from 'immer';

// eslint-disable-next-line no-unused-vars
import { NavState } from '../types';
// eslint-disable-next-line no-unused-vars
import { Action } from '../../../../types';
import { SET_NAV_ITEM } from '../actions';
import { setNavItem } from './set-nav-item';

/**
 * @type {NavState}
 */
const initialState = {
    competition: {
        id: ''
    },
    season: {
        id: '',
        providerId: ''
    },
    round: ''
};

/**
 * @param {NavState} state - The Redux state.
 * @param {Action} action - The Redux action.
 * @returns {NavState} The updated Redux state.
 */
export const navReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_NAV_ITEM:
                setNavItem(draft, action.payload);
                break;
            default:
                draft;
        }
    });
};
